import { z } from 'zod';

import { CatalogItemStatusSchema } from '../services/catalog-item-status.schema.js';

export const ChangeProductStatusBodySchema = z.object({
  status: CatalogItemStatusSchema,
  reason: z.string().trim().max(500).optional(),
});

export type ChangeProductStatusBody = z.infer<typeof ChangeProductStatusBodySchema>;
